import {
	HelmetDexteel,
	useHasPermission,
	useUserContext,
} from "@dexteel/mesf-core";
import { Alert, Box, Button, Skeleton } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { SawTabletWorkspace } from "./SawTabletWorkspace";
import { getSawTabletAsset } from "./repositories/sawTabletRepository";
import {
	SAW_TABLET_ASSET_NAME,
	SAW_TABLET_PERMISSION,
} from "./sawTabletConfig";

const ShellLoading = () => (
	<Box role="status" aria-label="Loading Saw Tablet" sx={{ p: 3 }}>
		<Skeleton variant="text" width="50%" height={48} />
		<Skeleton variant="rounded" height={160} sx={{ mt: 2 }} />
	</Box>
);

const SawTabletContent = () => {
	const {
		data: asset,
		isLoading,
		error,
		refetch,
	} = useQuery({
		queryKey: ["sawTabletAsset", SAW_TABLET_ASSET_NAME],
		queryFn: getSawTabletAsset,
		staleTime: 5 * 60 * 1000,
		retry: false,
	});

	if (asset) {
		return (
			<SawTabletWorkspace assetId={asset.AssetId} assetName={asset.AssetName} />
		);
	}
	if (isLoading) return <ShellLoading />;

	return (
		<Alert
			severity="error"
			sx={{ m: 3 }}
			action={<Button onClick={() => void refetch()}>Retry</Button>}
		>
			{error instanceof Error ? error.message : "Unable to load the saw line."}
		</Alert>
	);
};

export const SawTabletPage = () => {
	const hasPermission = useHasPermission();
	const { isLoading } = useUserContext();

	return (
		<>
			<HelmetDexteel title="Saw Tablet" />
			{isLoading ? (
				<ShellLoading />
			) : hasPermission(SAW_TABLET_PERMISSION) ? (
				<SawTabletContent />
			) : (
				<Alert severity="warning" sx={{ m: 3 }}>
					You do not have permission to access Saw Tablet.
				</Alert>
			)}
		</>
	);
};
